import { Environment } from '@cp/shared/environment/environment.interface';
import {
  getAuth0Organization,
  getCompanyFromUrl,
  getGlobalDashboardUrl,
  getRecruitmentPortalUrl,
} from './environment.helper';

const tnsOrgId = 'org_lxiyPLBcto52zfwT';
const sngOrgId = 'org_hU0Nb9VOjY7SIJE7';

export const environment: Environment = {
  production: false,
  pwa: true,
  company: getCompanyFromUrl(window.location.origin),
  apiEndpoint: 'https://as-complianceportal-api-uat.azurewebsites.net',
  gtmId: 'GTM-57CXPQQ',
  auth0: {
    domain: 'auth-uat.tnssng.com',
    clientId: 'dSlz8npwTuejwkUZmFChmHL5ERYQeGBs',
    redirectUrl: `${window.location.origin}/callback`,
    logoutUrl: window.location.origin,
    organization: getAuth0Organization(
      window.location.origin,
      tnsOrgId,
      sngOrgId,
    ),
    errorPath: '/error',
  },
  tnsQnUrls: {
    classic: 'http://qa.thornbury-quick-nurse.com',
    pwa: 'https://integration.quicknurse-thornbury.online',
  },
  sngQnUrls: {
    classic: 'http://qa.scottish-quick-nurse.com:88',
    pwa: 'https://integration.quicknurse-theguild.online',
  },
  recruitmentPortalUrl: getRecruitmentPortalUrl(window.location.origin),
  globalDashboardUrl: getGlobalDashboardUrl(window.location.origin),
  postcoderApiUrl: 'https://ws.postcoder.com/pcw/',
  postcoderApiKey: 'PCW98-2ZWTF-9YDNH-S42VM',
  featureFlags: {
    firstUniform: false,
    trainingPayment: false,
    avatarUpload: false,
    touchless: true,
  },
};
